import React from 'react';
import styled from 'styled-components';
import { Store, ShoppingCart, History } from 'lucide-react';
import { ThemeColors, Spacing, Typography, BorderRadius, Shadows } from '../../styles/ThemeStyles';

interface NavigationTabsProps {
  activeTab: 'store-visit' | 'store-order' | 'store-history';
  onNavigate: (tab: 'store-visit' | 'store-order' | 'store-history') => void;
}

const NavigationContainer = styled.div`
  margin-bottom: ${Spacing.xl};
`;

const NavigationTabsContainer = styled.div`
  display: flex;
  background: white;
  border-radius: ${BorderRadius.lg};
  padding: ${Spacing.sm};
  box-shadow: ${Shadows.sm};
  border: 1px solid ${ThemeColors.border.light};
`;

const Tab = styled.button<{ $isActive?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${Spacing.sm};
  padding: ${Spacing.md} ${Spacing.lg};
  border: none;
  background: transparent;
  color: ${props => props.$isActive ? ThemeColors.primary.main : ThemeColors.text.secondary};
  font-size: ${Typography.fontSize.md};
  font-weight: ${props => props.$isActive ? Typography.fontWeight.semiBold : Typography.fontWeight.medium};
  cursor: pointer;
  border-radius: ${BorderRadius.md};
  transition: all 0.2s ease;
  position: relative;
  
  &:hover {
    background: ${ThemeColors.background.default};
    color: ${ThemeColors.primary.main};
  }
  
  ${props => props.$isActive && `
    background: linear-gradient(135deg, ${ThemeColors.background.default}, white);
    color: ${ThemeColors.primary.main};
    
    &::after {
      content: '';
      position: absolute;
      bottom: -${Spacing.sm};
      left: 50%;
      transform: translateX(-50%);
      width: 80%;
      height: 3px;
      background: linear-gradient(90deg, ${ThemeColors.primary.main}, ${ThemeColors.accent.main});
      border-radius: ${BorderRadius.sm};
    }
  `}
`;

export const NavigationTabs: React.FC<NavigationTabsProps> = ({ activeTab, onNavigate }) => {
  return (
    <NavigationContainer>
      <NavigationTabsContainer>
        <Tab 
          $isActive={activeTab === 'store-visit'}
          onClick={() => onNavigate('store-visit')}
        >
          <Store size={18} />
          Stores
        </Tab>
        <Tab 
          $isActive={activeTab === 'store-order'}
          onClick={() => onNavigate('store-order')}
        >
          <ShoppingCart size={18} />
          Store Order
        </Tab>
        <Tab 
          $isActive={activeTab === 'store-history'}
          onClick={() => onNavigate('store-history')}
        >
          <History size={18} />
          Order History
        </Tab>
      </NavigationTabsContainer>
    </NavigationContainer>
  );
};
